@import '../../theme/global';

:host {
  align-items: center;
  background: $base-light;
  border-radius: 10px;
  box-shadow: $box-shadow-base;
  display: flex;
  flex-direction: column;
  padding: 16px;
  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
  }
}
